import { Toast as InnerToast, info, success } from './toast';
const Toast = InnerToast;
Toast.info = info;
Toast.success = success;
export default Toast;
